import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import { installAuthedFileLinks } from './lib/authedFiles';
import { SessionProvider } from './lib/session';
import { ConfigError } from './pages/ConfigError';
import { configProblems } from './shared/config';

const root = createRoot(document.getElementById('root')!);

// A production bundle built from a bad env (see shared/config.ts) gets a wall,
// not a portal that silently talks to localhost.
if (configProblems.length > 0) {
  root.render(
    <StrictMode>
      <ConfigError problems={configProblems} />
    </StrictMode>,
  );
} else {
  installAuthedFileLinks();
  root.render(
    <StrictMode>
      <BrowserRouter>
        <SessionProvider>
          <App />
        </SessionProvider>
      </BrowserRouter>
    </StrictMode>,
  );
}
